export const colorAccent = '#ea1313';
export const colorDarkPrimary = '#191b1f';
export const colorLightPrimary = '#e7dfe4';
export const cryptoImagesDomen = 'https://www.cryptocompare.com';

export const IS_SERVER = typeof window === 'undefined';
export const IS_CLIENT = typeof window !== 'undefined';
